var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m120.52,70.92v43.75H16.48v-43.75H1.98v58.25h133.03v-58.25h-14.5Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.98,1.83v55.66h14.5V16.33h104.03v41.15h14.5V1.83H1.98Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.12,48.8l7.9-8.93-.04-.08-8.15,3.27-.36-1.57,6.96-8.03-.04-.06-10.25,4.4-1.31-1.06c-1.39-1.19-2.84-2.07-4.45-2.71-2.16-.88-4.5-1.26-6.76-1.1-2.24.14-4.48.76-6.47,1.8-2.04,1.1-3.79,2.53-5.2,4.28-1.47,1.8-2.54,3.95-3.1,6.21-.49,2.01-.54,4.1-.16,6.56.05.35.19.87.19.87l.24.92-.89-.32c-12.85-4.67-27.12-11.98-33.03-15.11l-1.82,2.22.32,3.48c.8,9.12,5.64,13.3,5.69,13.34l1.84,1.55-7.43-2.23-1.29,2.26,1.06,3.79c1.32,2.79,5.5,7.45,9.23,8.53.83.35,1.48.56,2.06.65l-.07.99-5.54.09-.53,2.68,1.87,2.01c3.83,3.96,9.95,5.71,12.4,6.28l1,.26-.59.62q-.13.13-21.37,5.66v2.58l4.32,2.17c3.13,1.34,12.9,2.58,18.64,2.36,14.47-.55,27.31-8.29,32.41-13.36,9.86-9.79,13.02-25.02,12.72-35.07v-.2Z",
    style: {
      fill: "#d65e38"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOrange);
export default __webpack_public_path__ + "static/media/Twitter.Orange.0b18fa4a062549afdaf5b0788ea81a77.svg";
export { ForwardRef as ReactComponent };